import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "218.4 -46.5 283.1 302",
  "content": "<symbol viewBox=\"218.4 -46.5 283.1 302\" id=\"icon-calendar\">\r\n<path d=\"M312.8,66.8h37.8v37.8h-37.8V66.8z M369.4,66.8h37.8v37.8h-37.8V66.8z M426.1,66.8h37.8v37.8h-37.8V66.8z M256.2,180h37.8\r\n\tv37.8h-37.8V180z M312.8,180h37.8v37.8h-37.8V180z M369.4,180h37.8v37.8h-37.8V180z M312.8,123.4h37.8v37.8h-37.8V123.4z\r\n\t M369.4,123.4h37.8v37.8h-37.8V123.4z M426.1,123.4h37.8v37.8h-37.8V123.4z M256.2,123.4h37.8v37.8h-37.8V123.4z M463.8-46.5v18.9\r\n\th-37.8v-18.9H293.9v18.9h-37.8v-18.9h-37.8v302h283.1v-302H463.8z M482.7,236.6H237.3V29h245.4V236.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/calendar.svg
// module id = Rrki
// module chunks = 0